import { useEffect, useState } from "react";

import { fetchTeamMembers, type TeamMemberPayload } from "../services/teamService";

export const useTeam = () => {
  const [teamMembers, setTeamMembers] = useState<TeamMemberPayload[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadTeam = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchTeamMembers();
        if (isMounted) {
          setTeamMembers(data);
        }
      } catch (err) {
        console.error("Failed to load team members", err);
        if (isMounted) {
          setError(err instanceof Error ? err.message : "Failed to load team members");
          setTeamMembers([]);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadTeam();

    return () => {
      isMounted = false;
    };
  }, []);

  return { teamMembers, loading, error };
};

